import { useContext } from "react";
import { abpnClient } from "../../../../Services/AbpnClient";
import { AuthContext } from "../../../Auth/AuthProvider";
import { CCBlock, CCBlockRequirementType } from "../../../Physician/Models/CCBlock";
import { CCEnrollment } from "../../../Physician/Models/CCEnrollment";
import { MedicalLicense } from "../../../Physician/Models/MedicalLicense";
import Physician from "../../../Physician/Models/Physician";
import { StateWithCountryLookupItem } from "../../../Shared/Models/StateWithCountryLookupItem";
import { deepCopy } from "../../../Shared/Utility/DeepCopy";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";
import CCBlockCard from "./CCBlockCard";

interface IProps {
    currentEnrollment: CCEnrollment
    states: Array<StateWithCountryLookupItem>;
    physician: Physician;
    updatePhysician: (physician: Physician) => void;
}
export default function CCEnrollmentCard(props: IProps) { 
    const currentBlock = props.currentEnrollment.currentCCBlock
    const isBehindOnCurrentBlock = props.physician.currentCCEnrollment.isBehindCurrentBlock;
    const nextBlock = props.currentEnrollment.ccBlocks?.find(_ => getDateWithOffset(_.startDate) > getDateWithOffset(currentBlock.endDate));
    const isMeetingLicenseRequirement = !currentBlock.outstandingRequirements?.some(_ => _.requirementType === CCBlockRequirementType.MedicalLicense);
    const authContext = useContext(AuthContext);
    const contactAddress = props.physician.addresses.addresses.find(_ => _.isContact);

    const evaluateCurrentBlockAndCallUpdate = async (physician : Physician) => {
        if (props.physician.currentCCEnrollment == null) return;
        
        const ccBlock = await abpnClient.get<CCBlock>("/api/physician/EvaluateCurrentBlockRequirements", authContext);

        var index = physician.currentCCEnrollment.ccBlocks.findIndex(_ => _.ccBlockId === ccBlock.ccBlockId);
        physician.currentCCEnrollment.ccBlocks.splice(index, 1, ccBlock);
        physician.currentCCEnrollment.currentCCBlock = ccBlock;
        
        props.updatePhysician(physician);
    } 

    const onSaveBlock = (updatedBlock: CCBlock) => {
        var updatedPhysician = deepCopy(props.physician);
        var index = updatedPhysician.currentCCEnrollment.ccBlocks.findIndex(_ => _.ccBlockId === updatedBlock.ccBlockId);
        updatedPhysician.currentCCEnrollment.ccBlocks.splice(index, 1, updatedBlock);

        evaluateCurrentBlockAndCallUpdate(updatedPhysician);
    }

    const onSaveLicenses = (licenses: Array<MedicalLicense>) => {
        var updatedPhysician = deepCopy(props.physician);
        updatedPhysician.medicalLicenses = licenses;

        evaluateCurrentBlockAndCallUpdate(updatedPhysician);
    }

    return (
        <div>
            <CCBlockCard
                email={props.physician.emailAddress}
                contactAddress={contactAddress}
                ccEnrollment={props.currentEnrollment}
                ccBlock={currentBlock}
                ccVerifiedActivities={props.physician.ccVerifiedActivities}
                onSaveBlock={(updatedBlock: CCBlock) => onSaveBlock(updatedBlock)}
                medicalLicenses={props.physician.medicalLicenses}
                states={props.states}
                onSaveLicenses={(licenses: Array<MedicalLicense>) => onSaveLicenses(licenses)}
                hideLicenses={isBehindOnCurrentBlock ? isMeetingLicenseRequirement : false} 
                isPhysicianPatientSafetyRequired={props.physician.isPatientSafetyRequired} 
                physician={props.physician}
                updatePhysician={props.updatePhysician}
                />
            {
                nextBlock != null &&
                <CCBlockCard
                    email={props.physician.emailAddress}
                    contactAddress={contactAddress}
                    ccEnrollment={props.currentEnrollment}
                    ccBlock={nextBlock}
                    ccVerifiedActivities={props.physician.ccVerifiedActivities}
                    onSaveBlock={(updatedBlock: CCBlock) => onSaveBlock(updatedBlock)}
                    medicalLicenses={props.physician.medicalLicenses}
                    states={props.states}
                    onSaveLicenses={(licenses: Array<MedicalLicense>) => onSaveLicenses(licenses)}
                    hideLicenses={!isMeetingLicenseRequirement} 
                    physician={props.physician}
                    updatePhysician={props.updatePhysician}
                    isPhysicianPatientSafetyRequired={props.physician.isPatientSafetyRequired} />
            }
        </div >
    );
}